import type { TriageDepth } from '@/queries/investigations';

const DEPTH_LABEL: Record<TriageDepth, string> = {
  reply: 'answer directly',
  light: 'light investigation',
  deep: 'deep investigation'
};

export function triageDepthLabel(depth: TriageDepth): string {
  return DEPTH_LABEL[depth];
}
